const img = path => `/img/${path}`;
const icons = path => img(`icons/${path}`);
const municipality = name => `/img/municipality_logos/${name}.png`

export default {
  susasanLogo: img('susasan-logo.svg'),
  susasanLogoBlue: img('susasan-logo-blue.svg'),
  banner: img('hero-image.jpg'),
  pageNotFound: img('page-not-found.svg'),
  icons: {
    search: icons('search.svg'),
    searchSmall: icons('search-small.svg'),
    searchSmallBlue: icons('search-small-blue.svg'),
    link: icons('link.svg'),
    leaf: icons('leaf.svg'),
    back: icons('direction.svg'),
    backTeal: icons('back-teal.svg'),
    forward: icons('forward.svg'),
    forwardBlue: icons('forward-blue.svg'),
    download: icons('download.svg'),
    noData: icons('no-data.svg'),
    downArrow: icons('drop-down.svg'),
    toggleArrow: icons('toggle-arrow.svg'),
    filter: icons('filter.svg'),
    mail: icons('mail.svg'),
    cross: icons('cross.svg'),
    networkError: icons('network-error.svg'),
    message: icons('message.svg')
  },
  municipality_logo: {
    Mellekh : municipality('Mellekh'),
  }
};



// WEBPACK FOOTER //
// ./src/config/images.js